import { createBrowserHistory } from "history";
import { useMemo } from "react";

// TODO: Discus whether to get this from useGlobalContext
declare let custom: any;

// TODO: Move to a helper file
const setTitle = (hashPath: string = window.location.hash) => {
	const stepPages = hashPath.includes("demo/create");
	const context = hashPath.split("/")[1];

	// Verifies if current demo is a custom demo or base demo
	const customDemo = custom.environment === "custom";

	// Declares company names for page title
	const sampleGroupCompanyName = custom.companyName === "Sample Group";
	const customCompanyName = `${custom.companyName} Demos`;

	// Sets page title for the web demo (not for the web demo builder)
	const companyNamePageTitle = sampleGroupCompanyName
		? "Custom Demos"
		: customCompanyName;
	const demoPageTitle = customDemo ? companyNamePageTitle : "Principal Demos";

	const pageNotFound = `Page Not Found | ${demoPageTitle}`;

	// TODO(BUG): when cancel is pressed (MANAGER) reset the steps
	const title = {
		builder: {
			main: stepPages
				? "Step 1: Company Information | Principal Web Demo Builder"
				: "Principal Web Demo Builder",
			disallow: pageNotFound,
		},
		demo: demoPageTitle,
	};

	const maps = new Map([
		[
			"customize",
			!customDemo ? title.builder.main : title.builder.disallow,
		],
	]);
	return (document.title = maps.get(context) || title.demo);
};

const useTitleManagement = () => {
	const history = createBrowserHistory();

	// Used to set page title on refresh
	setTitle();

	return useMemo(() => {
		const listener = history.listen((historyObj) => {
			const { hash } = historyObj;
			setTitle(hash);
		});
		return () => {
			listener();
		};
	}, [history]);
};

export default useTitleManagement;
